import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { PromoBanner } from "./components/PromoBanner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { BikeCatalogue } from "./components/BikeCatalogue";
import { AccessoriesSection } from "./components/AccessoriesSection";
import { DealsSection } from "./components/DealsSection";
import { TrailFeed } from "./components/TrailFeed";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import Admin from "./pages/Admin";
import { TermsPage, PrivacyPage, ReturnsPage } from "./pages/Legal";

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    let hashTimer;
    if (window.location.hash) {
      hashTimer = setTimeout(() => {
        window.__lenis?.scrollTo(window.location.hash, { offset: -70 });
      }, 700);
    }
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(hashTimer);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-forest-deep text-bone">
      <div className="grain-overlay" />
      <PromoBanner />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <BikeCatalogue />
        <AccessoriesSection />
        <DealsSection />
        <TrailFeed />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/returns" element={<ReturnsPage />} />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#12161F",
            border: "1px solid rgba(255,56,21,0.4)",
            color: "#FFFFFF",
            borderRadius: "2px",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
